import { connect, mapProps, mapReadPretty } from '@formily/react'
import { DatePicker as AntdDatePicker } from 'antd'

import { ProDatePicker } from '@eastcoal/common/components/ProDatePicker'

import { mapDateFormat } from './util'

export const DatePicker = connect(
  ProDatePicker,
  mapReadPretty(ProDatePicker, {
    disabled: true
  }),
  mapProps(mapDateFormat({ isRange: false }))
) as typeof ProDatePicker

export const DateRangePicker = connect(
  AntdDatePicker.RangePicker,
  mapReadPretty(AntdDatePicker.RangePicker, {
    disabled: true,
    allowEmpty: true
  }),
  mapProps(mapDateFormat({ isRange: true }))
) as typeof AntdDatePicker.RangePicker
